export default "__VITE_ASSET__NM7sm0JP__"